import { useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';

import { type RetailerFields } from '@features/Cashback/Calculator/SpendBrand/types';
import { type CategoryFields } from '@features/Cashback/Calculator/SpendCategory/types';
import { categories } from '@features/Cashback/Calculator/constants/categories';
import { isNullish } from '@utils/isNullish';

import { useCashbackCalculatorContext } from '../CalculatorProvider/CalculatorContext';

type WatchedFields = CategoryFields & { cbcCalcBrandFields: RetailerFields };

// Turns "include cashback earnings" on the first time the user changes a
// category from its default or adds a brand; never turns it back off.
const IncludeCashbackWatcher = () => {
  const { values } = useFormikContext<WatchedFields>();
  const { initialFormValues, setUseCashbackValueInComms } =
    useCashbackCalculatorContext();
  const wasInteractedRef = useRef(false);

  const initialCategoryValues = initialFormValues as CategoryFields;
  const hasChangedCategory = categories.some(
    ({ id }) => values[id] !== initialCategoryValues[id]
  );
  const hasAddedBrand = Object.values(values.cbcCalcBrandFields ?? {}).some(
    (value) => !isNullish(value)
  );
  const interacted = hasChangedCategory || hasAddedBrand;

  useEffect(() => {
    if (interacted && !wasInteractedRef.current) {
      setUseCashbackValueInComms(true);
    }
    wasInteractedRef.current = interacted;
  }, [interacted, setUseCashbackValueInComms]);

  return null;
};

export { IncludeCashbackWatcher };
